import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "chevron-grabber-vertical" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: "Vector",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M7.93934 3.74989C8.52513 3.1641 9.47487 3.1641 10.0607 3.74989L12.5303 6.21956C12.8232 6.51245 12.8232 6.98732 12.5303 7.28022C12.2374 7.57311 11.7626 7.57311 11.4697 7.28022L9 4.81055L6.53033 7.28022C6.23744 7.57311 5.76256 7.57311 5.46967 7.28022C5.17678 6.98732 5.17678 6.51245 5.46967 6.21956L7.93934 3.74989L8.46967 4.28022L7.93934 3.74989ZM5.46967 10.7196C5.76256 10.4267 6.23744 10.4267 6.53033 10.7196L9 13.1892L11.4697 10.7196C11.7626 10.4267 12.2374 10.4267 12.5303 10.7196C12.8232 11.0125 12.8232 11.4873 12.5303 11.7802L10.0607 14.2499C9.47487 14.8357 8.52513 14.8357 7.93934 14.2499L5.46967 11.7802C5.17678 11.4873 5.17678 11.0125 5.46967 10.7196Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }